module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/rustic-15d32f2719cd0e3d80e8cca9d9ab07d9.jpg";